var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_flexcol _gap-1 _py-3 _px-2",
      attrs: { "data-qa": `pledges-dashboard-row:${_vm.orderID}` },
    },
    [
      _c(
        "backer-center-header",
        {
          scopedSlots: _vm._u([
            {
              key: "prefix",
              fn: function () {
                return [
                  _c("backer-center-thumbnail", {
                    attrs: {
                      url: _vm.yourPledgeUrl,
                      "image-url": _vm.imageUrl,
                      name: _vm.name,
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "suffix",
              fn: function () {
                return [
                  _c(
                    "base-text",
                    {
                      attrs: {
                        level: "b1",
                        "data-qa": "order-card:TotalAmount",
                      },
                    },
                    [_vm._v(_vm._s(_vm.totalAmountFormatted))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "base-text",
            {
              staticClass: "_toe",
              attrs: {
                as: "a",
                level: "b1",
                title: _vm.name,
                href: _vm.yourPledgeUrl,
                "data-qa": "order-card:ProjectName",
              },
            },
            [_vm._v("\n            " + _vm._s(_vm.name) + "\n        ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("order-statuses-list", {
            attrs: {
              "order-stage": _vm.stage,
              "payment-status": _vm.paymentStatus,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-text",
        { staticClass: "_tc--light", attrs: { level: "caption" } },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.Resources.format(
                  _vm.Resources.Common.ElementModifiedParagraph,
                  _vm.updatedAtFormatted
                )
              ) +
              "\n    "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }